// REACT & REDUX
import React, { Component } from "react";
import { NotificationContainer, NotificationManager } from "react-notifications";

// STYLE, PROPS & TRANSLATIONS
import "react-notifications/lib/notifications.css";

// COMMON

// COMPONENTS
import { Brand, CardBody, Button, FlexContainer } from "careconnect-ui";

// CONTAINERS

// ACTIONS & API
import { loginSuccess, authenticatedSuccess, setAuthenticationError } from "../../actions/authentication.actions";
import * as loginHttp from "../../api/login.api";

// *************************************************************************************************************************************

export class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loginProcedurePhase: 0
        };

        this.userInfo = undefined;
    }

    onLogin = (event, token) => {
        event.preventDefault();
        this.setState({ loginSubmitted: true });

        loginHttp.login().then();
    };

    userInfoReceived = userInfo => {
        if (userInfo.userId === undefined) {
            // user not found
            this.props.dispatch(setAuthenticationError("Please check your username and/or password."));
            return;
        }

        this.props.dispatch(authenticatedSuccess(userInfo));
        this.userInfo = userInfo;

        this.setState({ loginProcedurePhase: 1 });

        this.loginCompleted();
    };

    loginCompleted = () => {
        this.props.dispatch(loginSuccess());
        this.props.history.push("/");
    };

    onInputChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value });
    };

    renderError = () => {
        if (this.props.errorMessage && this.props.errorMessage !== "") {
            return NotificationManager.error(this.props.errorMessage, "Click me!", 5000, () => {});
        } else {
            return <p />;
        }
    };

    render() {
        //const { t } = this.props;
        const styles = {
            container: {
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "center"
            },
            root: {
                padding: 2
            }
        };

        return (
            <div style={styles.container} className="o-flex o-flex--vertical">
                <NotificationContainer />
                <FlexContainer vertical center>
                    <br />
                    <Brand logo="./images/mark.svg" brandName="CareConnect" productName="PPHR" size="large" />
                    <br />
                    <CardBody>
                        <form>
                            <p>Click to login with Corilus passport.</p>
                            <p>&nbsp;</p>
                            <center>
                                <Button styleType="primary" type="button" text="Login" onClick={this.onLogin} />
                            </center>
                            <p>&nbsp;</p>
                        </form>
                    </CardBody>
                </FlexContainer>
            </div>
        );
    }
}
